import { render, staticRenderFns } from "./template-list.vue?vue&type=template&id=5d8d0dba&scoped=true&"
import script from "./template-list.vue?vue&type=script&lang=js&"
export * from "./template-list.vue?vue&type=script&lang=js&"
import style0 from "./template-list.vue?vue&type=style&index=0&id=5d8d0dba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8d0dba",
  null
  
)

export default component.exports